import {Component} from '@angular/core';
import {User} from '../../models/User';
import {AuthService} from '../../shared/services/auth.service';
import {ADMINISTRATOR} from '../../shared/services/user.service';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent {
  user: User;
  isAdmin: boolean;

  constructor(private authService: AuthService) {
    this.user = this.authService.getUser();
    const originalUser = this.authService.getUser(true);
    this.isAdmin = originalUser.profile_id === ADMINISTRATOR;
  }
}
